import { useEffect } from "react";

import { UseQueryOptions, useSuspenseQuery } from "@tanstack/react-query";

import { useGetRegulatoryListFilterData } from "@/components/business/RegulatoryContainer/hooks/useGetRegulatoryFilterData";
import { queryClient } from "@api/queryClient";
import { useRegulatoryListFilterState } from "@stores/regulatoryList";

import { regulatoryListApis } from "./regulatory.service";
import { REGULATORY_QUERY_KEYS } from "../queryKey";

import type {
  RegulatoryFilteringData,
  PostRegulatoryListFilterResponse,
} from "@interface/regulatoryList.interface";

export const useRegulatoryListFilterQuery = (
  options?: UseQueryOptions<
    PostRegulatoryListFilterResponse,
    unknown,
    PostRegulatoryListFilterResponse,
    [string, RegulatoryFilteringData]
  >,
) => {
  const filteringData = useGetRegulatoryListFilterData();

  const [, setRegulatoryListFilter] = useRegulatoryListFilterState();
  const query = useSuspenseQuery({
    queryKey: [
      REGULATORY_QUERY_KEYS.regulatoryListFilter,
      filteringData as RegulatoryFilteringData,
    ],
    queryFn: async () =>
      regulatoryListApis.post(filteringData as RegulatoryFilteringData),
    staleTime: 0,
    refetchInterval: 2000,
    ...options,
  });

  useEffect(() => {
    setRegulatoryListFilter((prev) => ({
      ...prev,
      maxPage: query.data.totalPages,
      regulatoryListDataTotal: query.data.total,
    }));
  }, [query.data.totalPages, query.data.total, setRegulatoryListFilter]);

  return query;
};

export const invalidateRegulatoryTableDataQuery = () => {
  return queryClient.invalidateQueries({
    queryKey: [REGULATORY_QUERY_KEYS.regulatoryListFilter],
  });
};
